export default "__VITE_ASSET__CcvMYMLJ__"